var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "modal fade",
      attrs: {
        id: "uk-modal",
        tabindex: "-1",
        role: "dialog",
        "data-keyboard": "false",
        "data-backdrop": "static",
      },
    },
    [
      _c(
        "div",
        { staticClass: "modal-dialog modal-lg modal-dialog-centered" },
        [
          _c("div", { staticClass: "modal-content" }, [
            _c("div", { staticClass: "modal-body" }, [
              _c("div", { staticClass: "uk-modal__content" }, [
                _c("div", { staticClass: "uk-modal__body" }, [
                  _vm._m(0),
                  _vm._v(" "),
                  _c("div", { staticClass: "uk-modal__headline" }, [
                    _vm._v(
                      "\n                            " +
                        _vm._s(
                          _vm.$translate(
                            "OD3dprimaV2::Template.ukModalHeadline"
                          )
                        ) +
                        "\n                        "
                    ),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "uk-modal__subheadline" }, [
                    _vm._v(
                      "\n                            " +
                        _vm._s(
                          _vm.$translate(
                            "OD3dprimaV2::Template.ukModalSubheadline"
                          )
                        ) +
                        "\n\n                        "
                    ),
                  ]),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "uk-modal__footer" }, [
                  _c(
                    "a",
                    {
                      staticClass: "btn btn-primary",
                      attrs: {
                        href: _vm.$translate(
                          "OD3dprimaV2::Template.ukModalToWebsiteLink"
                        ),
                        target: "_blank",
                      },
                    },
                    [
                      _c("i", { staticClass: "flag-icon flag-icon-en" }),
                      _vm._v(
                        "\n                            " +
                          _vm._s(
                            _vm.$translate(
                              "OD3dprimaV2::Template.ukModalToWebsiteBtn"
                            )
                          ) +
                          "\n                        "
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "span",
                    {
                      staticClass: "btn btn-primary-outline",
                      on: {
                        click: function ($event) {
                          return _vm.closeModal()
                        },
                      },
                    },
                    [
                      _c("i", { staticClass: "flag-icon flag-icon-eu" }),
                      _vm._v(
                        "\n                            " +
                          _vm._s(
                            _vm.$translate(
                              "OD3dprimaV2::Template.ukModalContinueBtn"
                            )
                          ) +
                          "\n                        "
                      ),
                    ]
                  ),
                ]),
              ]),
            ]),
          ]),
        ]
      ),
    ]
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "uk-modal__flag" }, [
      _c("i", { staticClass: "flag-icon flag-icon-en" }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }